export function BrandMark({ className = '' }) {
  return (
    <span className={className ? `brand-mark ${className}` : 'brand-mark'}>
      <span className="brand-text">
        <span className="brand-text-main">agentic</span>
        <span className="brand-text-accent">hire</span>
      </span>
      <svg
        className="brand-icon"
        width="16"
        height="20"
        viewBox="0 0 356 347"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M141.5 77L72.5 142"
          stroke="currentColor"
          strokeWidth="35"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M283.5 185L199.5 269"
          stroke="currentColor"
          strokeWidth="35"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M81.5 164H274.5"
          stroke="currentColor"
          strokeWidth="35"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M306.5 195C324.173 195 338.5 180.897 338.5 163.5C338.5 146.103 324.173 132 306.5 132C288.827 132 274.5 146.103 274.5 163.5C274.5 180.897 288.827 195 306.5 195Z"
          stroke="currentColor"
          strokeWidth="35"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M49.5 195C67.1731 195 81.5 180.897 81.5 163.5C81.5 146.103 67.1731 132 49.5 132C31.8269 132 17.5 146.103 17.5 163.5C17.5 180.897 31.8269 195 49.5 195Z"
          stroke="currentColor"
          strokeWidth="35"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M226.466 301.444L146.205 326.246L164.856 244.337L226.466 301.444Z"
          stroke="currentColor"
          strokeWidth="28"
        />
        <rect
          x="139"
          y="17.5"
          width="66"
          height="65"
          stroke="currentColor"
          strokeWidth="35"
        />
      </svg>
    </span>
  );
}
